<template>
  <div class="share-page" v-show="url" @click="$emit('close')">
    <img :src="url" alt="" id="card">
    <div id="qrcode" v-show="false"></div>
    <div class="longpress">
      长按即可保存图片
    </div>
  </div>
</template>

<script>
  import {toHTML, getCutImageUrl, cutImage} from "./toHtml";
  import api from "../../api/api-list/index"
  import WNavBar from '../../components/global/w-navbar'
  import { envMixin } from '../../assets/js/mixin/global'
  export default {
    name: "job-share",
    data(){
      return {
        url: ""
      }
    },
    mixins: [envMixin],
    props:['job', 'hr', 'company'],
    components:{WNavBar},
    mounted() {
      const toast = this.$createToast({
        txt: '生成中',
        type: 'loading',
        mask: true,
        time: 0
      })
      toast.show()
      let job = this.job
      let hr = this.hr
      let company = this.company

      new QRCode(document.getElementById("qrcode"),{
        text: `${window.location.origin}/jobs/${job.token}.html`
      });
      let canvas = document.querySelector("#qrcode > canvas")
      api.jobs.renderImage(toHTML({job, hr, company, code: canvas.toDataURL()}), job.token + 'job-card').then((res)=>{
        if(res.code === 1000){
          let { url } = res.data
          return getCutImageUrl(url)
        }
      }).then(res => {
        this.url = res
        toast.hide()
      })
    },
    methods:{
      toBack(){
        this.$router.back()
      }
    }
  }
</script>

<style scoped lang="scss">

  .share-page{
    width: 100vw;
    min-height: 100%;
    background: #000000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 100;
    top:0;
    #card{
      width: 100%;
      margin-top: 0px;
    }
    .navbar {
      position: fixed;
      left: 0;
    }
    .longpress{
      margin-top: 20px;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #9C9C9C;
      line-height: 22px;
    }
  }
</style>
